<div class="host">
  <app-toolbar>
  </app-toolbar>
  <app-graphics>
  </app-graphics>
  <div class="content" fxLayout="column">
    <mat-table [dataSource]="table" class="full-width mat-elevation-z8" matSort matSortStart="desc">
      <ng-container matColumnDef="country" sticky>
        <mat-header-cell *matHeaderCellDef mat-sort-header start="asc">Country </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img class="small-icon" src={{element.flag}}/> {{element.country}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cases">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell"> T </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.cases}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="delta">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell active-color"> &Delta;T </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.delta}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell warn active-color"> A </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.active}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="recovered">
        <mat-header-cell *matHeaderCellDef class="align-right-cell recovered-color" mat-sort-header> R </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.recovered}} </mat-cell>>
      </ng-container>

      <ng-container matColumnDef="deaths">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell deaths-color"> D </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.deaths}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="activeDelta">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell active-color"> &Delta;A </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.activeDelta}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="recoveredDelta">
        <mat-header-cell *matHeaderCellDef class="align-right-cell recovered-color" mat-sort-header> &Delta;R </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.recoveredDelta}} </mat-cell>>
      </ng-container>

      <ng-container matColumnDef="deathsDelta">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell deaths-color"> &Delta;D </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.deathsDelta}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="critical">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell active-color"> C </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.critical}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="infectionRate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell"> <div style="margin-bottom: -4px;">r<sub>0</sub></div> </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.infectionRate | number:'1.1-1'}}%</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="reproductionNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell"> <div style="margin-bottom: -4px;">R<sub>0</sub></div> </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> {{element.reproductionNumber | number:'1.1-1'}}</mat-cell>>
      </ng-container>

      <ng-container matColumnDef="mobilityChange">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="align-right-cell"> M </mat-header-cell>>
        <mat-cell *matCellDef="let element" class="align-right-cell"> 
          <span *ngIf="element.mobilityChange"> {{element.mobilityChange | number:'1.0-0'}}%</span>
          <span *ngIf="!element.mobilityChange"> - - - - </span>
        </mat-cell>>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns" 
        [ngClass]="{'highlight': currentCountry == row}"
        (click)="selectCountry(row)">
      </mat-row>>
      <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>>

    </mat-table>

    <div style="margin: 15px;">
      <h1>Disclaimer & Credits</h1> 
      <p>Implemented by <a href="https://github.com/CodingOrca">Artur Pusztai</a></p>
      <p>The application is work in progress, not sufficiently tested, and not suitable for decision making.</p>
      <p>
        Covid-19 case data are provided by 
        <a href="https://systems.jhu.edu/" target="_blank">Johns Hopkins University</a> 
        and retrieved with the APIs provided by 
        <a href="https://github.com/NovelCOVID" target="_blank">NovelCOVID</a>
      </p>
      <p>Mobility profiles are provided by google: 
        <a href="https://www.google.com/covid19/mobility/" target="_blank">
          See how your community is moving around differently due to COVID-19</a> 
      </p>
      <p>
      Mortality rates are taken from 
      <a href="https://www.wolframalpha.com/input/?i=annual+deaths" target="_blank">Wolfram Alpha</a>.
      </p>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>